import { i18n as I18n } from 'i18next';

type Pattern = { key: string; regex: RegExp; variables: string[] };
const patterns = new WeakMap<object, Pattern[]>();

/** Translate existing formatted UI strings without changing their numeric values. */
export function translateText(i18n: I18n, text: string | number | null | undefined): string {
  // Numeric UI values (including zero) are data, not translation keys.
  if (typeof text === 'number') return String(text);
  if (text == null || text === '') return '';
  const options = { keySeparator: false as const, nsSeparator: false as const };
  const lookup = (value: string): string => {
    if (i18n.exists(value, options)) return i18n.t(value, options);
    const english = i18n.getResourceBundle('en', 'translation');
    if (english) {
      let entries = patterns.get(english);
      if (!entries) {
        entries = Object.entries(english)
          .filter(([key, value]) => key.startsWith('ui_template__') && typeof value === 'string')
          .map(([key, value]) => {
            const variables: string[] = [];
            const parts = (value as string).split(/(\{\{value\d+\}\})/g);
            const pattern = parts.map((part) => {
              if (/^\{\{value\d+\}\}$/.test(part)) {
                variables.push(part.slice(2, -2));
                return '([\\s\\S]*?)';
              }
              return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }).join('');
            return { key, variables, regex: new RegExp(`^${pattern}$`) };
          });
        patterns.set(english, entries);
      }
      for (const entry of entries) {
        const match = value.match(entry.regex);
        if (match) {
          const variables = Object.fromEntries(entry.variables.map((name, index) => [name, match[index + 1]]));
          return i18n.t(entry.key, { ...options, ...variables });
        }
      }
    }
    return value;
  };
  return lookup(text).replace(/\[\[(.*?)\]\]/g, (_, key) => lookup(key));
}
